import React from 'react';
import PropTypes from 'prop-types';
import CarouselImage from '../CarouselImage';
import { withTitle } from '../../../HOC';

const CarouselRender = ({
  handleNavigation,
  imageIds,
  listRef,
  shouldDisplayCount,
  shouldDisplayCaption,
  caption,
  countMessage,
  direction,
  priorityLimit,
  ...otherProps
}) => (
  <div className="carousel">
    <div>
      <div
        className="carousel__button carousel__button--previous"
        role="button"
        aria-label="Previous Slide"
        onClick={() => handleNavigation(direction.back)}>
        <div className="arrow arrow--left" />
      </div>
      <div className="carousel__list" ref={listRef}>
        {imageIds.map((imageId, index) => (
          <CarouselImage
            key={imageId}
            priority={index < priorityLimit}
            imageId={imageId}
            {...otherProps}
          />
        ))}
      </div>
      <div
        className="carousel__button carousel__button--next"
        role="button"
        aria-label="Next Slide"
        onClick={() => handleNavigation(direction.next)}>
        {shouldDisplayCount && <p data-testid="count">{countMessage}</p>}
        <div className="arrow arrow--right" />
      </div>
    </div>
    {shouldDisplayCaption && (
      <div className="carousel__details" data-testid="carousel-details">
        <div className="caption">{caption}</div>
      </div>
    )}
  </div>
);

CarouselRender.propTypes = {
  caption: PropTypes.string,
  shouldDisplayCaption: PropTypes.bool.isRequired,
  imageIds: PropTypes.array,
  displayCount: PropTypes.bool,
  listRef: PropTypes.object,
  countMessage: PropTypes.number,
  direction: PropTypes.object.isRequired,
  handleNavigation: PropTypes.func.isRequired,
  shouldDisplayCount: PropTypes.bool.isRequired,
  priorityLimit: PropTypes.number
};

CarouselRender.defaultProps = {
  listRef: null,
  imageIds: [],
  caption: '',
  displayCount: false,
  countMessage: null,
  priorityLimit: 0
};

export default withTitle(CarouselRender);
